var map = {
	"./sec-1-ar.png": 1228,
	"./sec-1-en.png": 1229,
	"./sec-2.png": 1230,
	"./sec-3-ar.png": 1231,
	"./sec-3-en.png": 1232,
	"./sec-4.png": 1233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1227;